export default __webpack_public_path__ + "static/media/close-icon.53612dd6.svg";